<template>
  <el-header class="root">
    <img src="@/img/apc_head_logo.svg"/>
    <div class="right" v-if="device === 'pc'">
      <span class="time">{{ getTime }}</span>
      <span class="username">ユーザー：{{username}}</span>
      <el-button class="logout-button" type="default" @click="signOut">ログアウト</el-button>
    </div>
    <div class="sp-right" v-else>
      <span>
        <el-badge class="item" :value="manageBadge.badgeString" :hidden="manageBadge.hiddenBadge" :type="manageBadge.badgeType">
          <i :class="classObject" @click="SpMenuHandler" />
        </el-badge>
      </span>
    </div>
  </el-header>
</template>

<script>
import { Auth } from 'aws-amplify';
import mixin from '@/mixin/mixin.js';

export default {
  name: 'HeaderContent',
  mixins: [mixin],
  props: {
      username: String,
      menuHandler: Boolean,
      badgeInfo: Object
  },
  
  data(){
    let now = new Date()
    return{
      now: now,
      badgeType: 'info',
      badgeString: '',
      hiddenBadge: true,
      showMenu: false,
      classObject: 'el-icon-s-unfold'
    }
  },

  computed: {
      getTime: function () {
        return this.now.getFullYear() + 
                "/" + ('0' + (this.now.getMonth()+1)).slice(-2) + 
                "/" + ('0' + this.now.getDate()).slice(-2) +
                " " + ('0' + this.now.getHours()).slice(-2) +
                ":" +('0' + this.now.getMinutes()).slice(-2) +
                ":" + ('0' + this.now.getSeconds()).slice(-2)
      },
      
      manageBadge: function() {
          return this.badgeInfo
      }
  },

  created: function() {
      //時計の更新
      setInterval(() => { this.now = new Date() }, 100)
  },

  methods: {
      signOut: async function(){
        try {
          await Auth.signOut();
          this.$emit("signOut")
          } catch (error) {
            console.log('error signing out: ', error);
          }
      },
      
      SpMenuHandler: function() {
        const isShowMenu = !this.showMenu
        this.showMenu = isShowMenu
        this.switchIcon()
        this.$emit('menuHandler', isShowMenu)
      },
      
      switchIcon: function() {
        if (this.showMenu) {
          this.classObject = 'el-icon-close'
        } else {
          this.classObject = 'el-icon-s-unfold'
        }
      }
  },
  
  watch: {
      menuHandler(val) {
          this.showMenu = val
          this.switchIcon()
      }
  }
  
}

</script>

<style scoped>
  .el-header {
    background-color: #e6e6fa;
    color: #333;
    line-height: 60px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
  }
  .root{
    display: flex;
    height: 60px;
    font-size: 12px;
  }

  img{
    width: 50%;
    max-width: 350px;
    max-height: 50px;
    margin: auto 0;
  }

  
  .right{
    margin-left: auto;
    display: block;
  }
  
  .sp-right{
    display: none;
  }
  
  .username{
      padding-left: 20px;
      padding-right: 10px;
      font-size: 14px;
  }
  
  .el-collapse-item__arrow{
      display: none;
  }
  
    
  /* SP用 */
  @media screen and (max-width:980px) {

    img{
      width: 35%;
      height: auto;
    }
    
    .right{
      display: none;
    }
    
    .root{
      padding-right: 0;
    }
    
    .sp-right{
      margin-left: auto;
      display: block;
    }

    span >>> .el-badge__content{
      top: 20px;
      right: 30px;
    }
    
    i{
      transform: scale(2.0);
      color: black;
      padding-right: 20px;
    }
    
  }
  
</style>